var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-wrapper",class:_vm.device},[_c('div',{staticClass:"card-holder"},[_c('div',{staticClass:"card",class:_vm.classList},[_vm._t("default")],2),_c('div',{staticClass:"overlay",on:{"click":_vm.close}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }